import { cn } from "@aircall/ds";

import { EvaluationComment } from "../EvaluationComment";
import { EvaluationQuestionSummaryRating } from "../EvaluationQuestionSummaryRating";

import { EvaluationQuestionSummaryProps } from ".";

export function EvaluationQuestionSummary<Rating extends string>({
  rank,
  question,
  value,
  maximumPoints,
  points,
  answerGuide,
  isNotApplicable = false,
  comment,
  className,
  ...wrapperProps
}: EvaluationQuestionSummaryProps<Rating>) {
  return (
    <div className={cn("flex flex-col gap-2", className)} {...wrapperProps}>
      <div className="flex items-center gap-6">
        <div className="flex flex-[3] gap-2">
          <p className="text-base font-semibold">{`${rank}.`}</p>
          <div className="flex flex-col gap-1">
            <p className="text-base font-semibold">{question}</p>
            <p className="text-xs font-normal">{answerGuide}</p>
          </div>
        </div>
        <EvaluationQuestionSummaryRating
          value={value}
          maximumPoints={maximumPoints}
          points={points}
          disabled={isNotApplicable}
        />
      </div>
      {comment && <EvaluationComment>{comment}</EvaluationComment>}
    </div>
  );
}
